import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { FormattedMessage, injectIntl } from 'react-intl'
import Icon from 'components/Icon'
import SearchIcon from 'icons/SearchIcon'
import CancelIcon from 'icons/CloseIcon'
import styles from './SearchWidget.css'
import Button from 'components/Button'
import debounce from 'lib/debounce'
import log from 'lib/log'
import { findRelativeAncestor } from 'lib/dom_utils'

class SearchControl extends Component {
  constructor(props) {
    super(props)
    this.state = { value: props.value || '' }
    this.handleRef = this.handleRef.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }
  componentDidMount() {
    const { onSearch = log.info } = this.props
    this.handleSearchDebounced = debounce(() => {
      onSearch.apply(this, [this.state.value])
    }, 500)
  }
  handleChange(ev) {
    this.setState({ value: ev.target.value })
    this.handleSearchDebounced()
  }
  handleRef(el) {
    if (el) el.focus()
  }
  render() {
    let { intl, placeholder, onClose, position } = this.props
    let { value } = this.state
    return (
      <div style={position} className={styles.search_control}>
        <input
          ref={this.handleRef}
          placeholder={intl.formatMessage({
            id: placeholder || 'search.placeholder'
          })}
          onChange={this.handleChange}
          value={value}
        />
      </div>
    )
  }
}

class SearchWidget extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.handleClick = this.handleClick.bind(this)
    this.capturePosition = this.capturePosition.bind(this)
    this.updatePosition = this.updatePosition.bind(this)
  }
  handleClick() {
    const { onCancelSearch } = this.props
    this.setState(s => {
      if (s.open && onCancelSearch) onCancelSearch()
      return { open: !s.open }
    })
  }
  componentDidMount() {
    if (window) {
      window.addEventListener('resize', this.updatePosition)
    }
  }
  componentWillUnmount() {
    if (window) {
      window.removeEventListener('resize', this.updatePosition)
    }
  }
  capturePosition(ref) {
    if (ref) {
      this.iconRef = ref
      this.updatePosition()
    }
  }
  updatePosition() {
    if (this.iconRef) {
      let el = ReactDOM.findDOMNode(this.iconRef)
      let ancestor = findRelativeAncestor(el)
      let { intl } = this.props
      if (intl.locale === 'en') {
        this.setState({ right_position: ancestor.offsetWidth - el.offsetLeft })
      } else {
        this.setState({ left_position: el.offsetLeft + el.offsetWidth })
      }
    }
  }
  render() {
    let { onSearch, intl, hidden, ...other } = this.props
    if (hidden) {
      return null
    }
    let { open, left_position, right_position } = this.state
    let position = {}
    if (left_position) position.left = left_position
    if (right_position) position.right = right_position
    return (
      <div className={styles.search_widget} {...other}>
        <a ref={this.capturePosition}>
          <Icon
            className={styles.icon}
            icon={open ? CancelIcon : SearchIcon}
            onClick={this.handleClick}
          />
        </a>
        {open ? (
          <SearchControl intl={intl} position={position} onSearch={onSearch} />
        ) : null}
      </div>
    )
  }
}

export default injectIntl(SearchWidget)
